export enum TimeFormat {
  "NOT_SET" = "notSet",
  "TWENTY_FOUR_HOUR" = "24hour",
  "TWELVE_HOUR" = "12hour",
}
